import { isEmpty, pick, propOr } from '../../utils/fp';
import facetsParser from './facetsParser';

export default parserArgs => data => {
  const locale = parserArgs?.config?.localeId;
  const configuredFacetsParser = facetsParser({
    config: propOr({}, 'config', parserArgs),
  });

  if (isEmpty(propOr([], 'facetIds', parserArgs)))
    return { locale, facets: configuredFacetsParser(data.facets) };

  const homeFacets = pick(parserArgs.facetIds, data.facets);
  const parsedHomeFacets = configuredFacetsParser(homeFacets);

  return { locale, facets: parsedHomeFacets };
};
